import {
  login as authLogin,
  logout as authLogout,
  me as authMe,
  showLoginModal,
  hideLoginModal,
} from './auth.js';
import { router } from './router.js';
import { initHeader } from './components/header.js';
import { initSidebar } from './components/sidebar.js';
import { initStatsBar } from './components/stats-bar.js';
import './styles/variables.css';
import './styles/main.css';
import './styles/admin.css';
import './styles/dhtmlx-overrides.css';
import './styles/volume.css';
import './styles/my-day.css';
import './styles/sidebar.css';
import './styles/stub.css';
import './styles/data-table.css';
import './styles/tenders.css';
import './styles/sheets.css';
import './styles/counterparties.css';
import './styles/normcontrol.css';
import './styles/tender-funnel.css';
import './styles/forms.css';   /* УИ-1: единая база форм/диалогов — импорт последним, чтобы перекрывать контролы форм во всех разделах */

function initApp() {
  hideLoginModal();
  initHeader();
  initSidebar();
  initStatsBar();
  router.init();
}

function setupLoginForm() {
  const form = document.getElementById('login-form');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const user = form.querySelector('#login-user').value.trim();
    const pass = form.querySelector('#login-pass').value;
    const errEl = document.getElementById('login-error');
    const btn = form.querySelector('button[type="submit"]');

    if (!user || !pass) return;

    btn.disabled = true;
    btn.textContent = 'Проверка...';
    if (errEl) errEl.style.display = 'none';

    try {
      await authLogin(user, pass);
      initApp();
    } catch (err) {
      if (errEl) {
        errEl.textContent = err.message || 'Ошибка входа';
        errEl.style.display = 'block';
      }
    } finally {
      btn.disabled = false;
      btn.textContent = 'Войти';
    }
  });
}

// Logout button delegated handler — кнопка появляется в header.js.
document.addEventListener('click', async (e) => {
  if (e.target?.dataset?.action === 'logout') {
    e.preventDefault();
    await authLogout();
    location.reload();
  }
});

setupLoginForm();

// На старте — проверяем cookie через /api/auth/me.
authMe().then((user) => {
  if (user) {
    initApp();
  } else {
    showLoginModal();
  }
});
